import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const BusinessContext = createContext(null);

export function BusinessProvider({ children }) {
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/businesses/current");
      setBusiness(data || null);
    } catch (_e) {
      setBusiness(null);
    } finally {
      setLoading(false);
    }
  }, []);

  // Phase 18 — Honour ?biz=<slug> by calling the public switch endpoint
  // BEFORE the first `/businesses/current` fetch. After switching we strip
  // the query param from the URL so reloading doesn't loop.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const slug = params.get("biz");
    const run = async () => {
      if (slug) {
        try {
          await api.post(`/public/switch-business/${encodeURIComponent(slug)}`);
        } catch (_e) {
          // Ignore — invalid slugs just fall back to the default tenant.
        }
        params.delete("biz");
        const qs = params.toString();
        const next = window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash;
        window.history.replaceState({}, "", next);
      }
      await refresh();
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BusinessContext.Provider value={{ business, loading, refresh }}>
      {children}
    </BusinessContext.Provider>
  );
}

export function useBusiness() {
  return useContext(BusinessContext) || { business: null, loading: false, refresh: () => {} };
}
